import type { ReactNode } from 'react';
import { Logo } from '../../components/ui/logo';
import { ThemeToggle } from '../../components/ui/theme-toggle';

/**
 * Centred card the guest challenge sits in.
 *
 * `html` has `overflow: hidden` app-wide, so this owns its own scrolling —
 * centred when it fits, scrollable when the card outgrows the viewport.
 */
export function GuestCard({ children }: { children: ReactNode }) {
	return (
		<div className="scroll-thin h-full overflow-y-auto">
			<div className="flex min-h-full flex-col items-center justify-center px-4 py-12">
				<div className="w-full max-w-[500px]">
					<div className="mb-8 flex items-center justify-between">
						<Logo />
						<ThemeToggle />
					</div>
					<div className="rounded-[var(--r-3)] border border-line-1 bg-surface px-6 py-7">
						{children}
					</div>
				</div>
			</div>
		</div>
	);
}
